module.exports = __webpack_public_path__ + "img/support-top-jp.a900326.png";